module.exports = __webpack_public_path__ + "img/7.3fbb54e.jpg";